var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 43"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.5 24.94c10.168 0 18.959 6.845 21.46 16.47a1.27 1.27 0 0 1-.924 1.55 1.285 1.285 0 0 1-1.565-.916c-2.21-8.506-9.982-14.558-18.971-14.558S4.739 33.538 2.529 42.044a1.285 1.285 0 0 1-1.565.915 1.27 1.27 0 0 1-.923-1.55C2.54 31.785 11.33 24.94 21.5 24.94M21.285 0C27.578 0 32.68 5.102 32.68 11.395S27.578 22.79 21.285 22.79 9.89 17.688 9.89 11.395 14.992 0 21.285 0m0 2.568a8.827 8.827 0 1 0 8.826 8.973l.001-.146v-.146a8.827 8.827 0 0 0-8.827-8.681"
  })));
};
export default SvgAccount;